/**
 * To camel case from snake case (for a server response)
 */

export function toCamelCaseString(str) {
  return str ? str.replace(/_([a-z])/g, g => g[1].toUpperCase()) : str
}

export function toCamelCaseObject(object) {
  if (object === null || typeof object !== 'object' || object instanceof Date) {
    return object
  }

  if (Array.isArray(object)) {
    return object.map(toCamelCaseObject)
  }

  return Object.entries(object).reduce((o, [key, value]) => {
    const newObject = { ...o }
    const newValue = toCamelCaseObject(value)
    const newKey = toCamelCaseString(key)
    newObject[newKey] = newValue
    return newObject
  }, {})
}

/**
 * To snake case from camel case (for a server request)
 */

export function toSnakeCaseString(str) {
  return str ? str.replace(/[A-Z]/g, g => `_${g[0].toLowerCase()}`) : str
}

export function toSnakeCaseObject(object) {
  if (object === null || typeof object !== 'object' || object instanceof Date) {
    return object
  }

  if (Array.isArray(object)) {
    return object.map(toSnakeCaseObject)
  }

  return Object.entries(object).reduce((o, [key, value]) => {
    const newObject = { ...o }
    const newValue = toSnakeCaseObject(value)
    const newKey = toSnakeCaseString(key)
    newObject[newKey] = newValue
    return newObject
  }, {})
}


export function validateDomain(domain) {
  /* eslint-disable-next-line */
  const regexp = /^((?!-))(xn--)?[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}\.(xn--)?([a-z0-9\-]{1,61}|[a-z0-9-]{1,30}\.[a-z]{2,})$/g
  return regexp.test(domain)
}

export function validatePhone(phone) {
  const regexp = /^[1-9]{1}[0-9]{8,15}$/g
  return regexp.test(phone)
}

export function validateEmail(email) {
  /* eslint-disable-next-line */
  const regexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regexp.test(email)
}

export function redirectToBackOrHome(from, next, home = { name: 'home' }) {
  if (from.name && from.path !== '/') {
    return next(from)
  }
  return next(home)
}

export function getDuringOrCustomDateRange(dateRange, customDateRange) {
  const { value = null } = dateRange || {}
  const during = ['ALL_TIME', 'OTHER_RANGE'].includes(value) ? null : value
  if (during) return during

  const { startDate = null, endDate = null } = customDateRange || {}
  return (startDate && endDate) ? `${startDate}, ${endDate}` : null
}

export function toFixed(value, digits) {
  const newValue = Number(value)
  if (!newValue) return value
  if (!digits && digits !== 0) return value
  return newValue.toFixed(digits)
}

export function equalsArray(
  array1,
  array2
) {
  if (array1 === array2) return true
  if (!array1 || !array2) return false
  return array1.length === array2.length && array1.every(item => array2.includes(item))
}
